// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  min-height: 0;
  position: relative;
}

.hidden {
  overflow: hidden;
  visibility: hidden;
}

.contents {
  width: 100%;
  height: 20vh;
}
`, "",{"version":3,"sources":["webpack://./src/examples/networks-and-flows/graph/graph-link-arrows/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".container {\n  min-height: 0;\n  position: relative;\n}\n\n.hidden {\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.contents {\n  width: 100%;\n  height: 20vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container`,
	"hidden": `hidden`,
	"contents": `contents`
};
export default ___CSS_LOADER_EXPORT___;
